<mat-dialog-content fxLayout="column" fxLayoutAlign="center center" class="readycheck-report-dialog">
    <div class="report-content">
        <div class="report-content-liner">
            <lti-iframe
                [user]="teacher"
                [assignment]="assignment"
                [asset]="asset"
                [course]="course"
                [launchType]="'edulastic-ready-check'"
                [destination]="readyCheckDestination"
                [studentAssignments]="studentAssignments"
            ></lti-iframe>
        </div>
        <div class="report-action">
            <button mat-raised-button color="primary" (click)="onCancel()">Close</button>
        </div>
    </div>

</mat-dialog-content>
